import BASEURL from '@/utils/BASE_URL';
// 小红书
export const BOOK = BASEURL.DY_CLOUD_API + '/book/api/';
// 营销模块
export const COMMERCE = BASEURL.DY_CLOUD_API + '/commerce/api/';

